import { Rate } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setCarts } from "../../store/actions/productAction";
import { useHistory } from "react-router-dom";

const Product = ({ product }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const add = (id) => {
    const data = {
      productId: id,
      qty: 1,
    };
    if (!isAuthenticated) {
      history.push("/login");
    } else {
      dispatch(setCarts(data, "add"));
    }
  };

  return (
    <>
      <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12">
        <div className="card mb-3">
          <img
            src={product.image}
            className="card-img-top product-img"
            alt="..."
          />
          <div className="card-body">
            <h5 className="card-title">{product.name}</h5>
            <p className="card-text">
              <small className="text-muted fs-5">
                category:{product.category}
              </small>
            </p>
            <div>
              <p className="fs-4 mb-0">₹ {product.cost}</p>
              <p>
                <Rate allowHalf defaultValue={product.rating} />
              </p>
            </div>
            <button
              className="btn btn-info rounded-pill mt-0"
              type="submit"
              onClick={() => add(product._id)}
            >
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
              Add to Card
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
